export default (url) => {
  let parts = url.split('_')
  if (parts.length < 2) {
    let parts2 = url.split('/')
    if (parts2.length < 2) { return false }
    return parts2[1]
  }
  return parts[parts.length - 2]
}
